import css from './style.module.scss';
import Wrap from '../Wrap';
import Prose from '../Prose';
import Button, { TYPED_LINK_FRAGMENT } from '../Button';
import { gql } from '../../util/fetchGql';
import cls from '../../util/cls';

export const TECHNICAL_PRODUCT_FRAGMENT = gql`
	fragment TechnicalProduct on productContent_technical_BlockType {
		heading
		text
		buttons {
			... on buttons_BlockType {
				key: id
				button {
					...TypedLink
				}
			}
		}
		details {
			heading
			text
		}
	}
	${TYPED_LINK_FRAGMENT}
`;

const Cell = ({ label, value }) => (
	<div className={css.cell}>
		<span>{label}</span>
		<strong>{value}</strong>
	</div>
);

export default function Technical ({ accent, heading, text, buttons = [], details = [] }) {
	return (
		<section className={cls(css.specWrap, { [css.blue]: accent === 'blue' })}>
			<Wrap grid className={css.grid}>
				<Prose className={css.text}>
					<h3>{heading}</h3>
					<p>{text}</p>
					<footer>
						{buttons.map(btn => <Button key={btn.key} {...btn.button} />)}
					</footer>
				</Prose>
				<div className={css.table}>
					{details?.map((detail, i) => (
						<Cell
							key={i}
							label={detail.heading}
							value={detail.text}
						/>
					))}
				</div>
			</Wrap>
		</section>
	);
}
